import { Box, Typography } from "@mui/material";
import React from "react";

export default function ProcessingBadge({ value, asset }) {
  return (
    <Box
      sx={{
        p: "3px 12px",
        display: "inline-flex",
        alignItems: "center",
        background: `var(--${asset?.color})`,
        color: `var(--${asset?.text}-txt)`,
        borderRadius: "100px",
      }}
    >
      <Typography
        variant="body2"
        fontWeight="bold"
        sx={{ height: "24px", whiteSpace: "nowrap" }}
      >
        {value}
      </Typography>
    </Box>
  );
}
